import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (localStorage.getItem("sk_admin_token")) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("sk_admin_token", data.access_token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--bg-secondary)" }} data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl p-8 md:p-10 space-y-5" style={{ background: "var(--surface)", border: "1px solid var(--border-soft)" }}>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] mb-2" style={{ color: "var(--primary-deep)" }}>Admin</div>
          <h1 className="font-display text-3xl" style={{ color: "var(--text-primary)" }}>Sign in</h1>
        </div>
        <label className="block">
          <span className="block text-sm mb-2" style={{ color: "var(--text-secondary)" }}>Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="al-input" data-testid="admin-email"/>
        </label>
        <label className="block">
          <span className="block text-sm mb-2" style={{ color: "var(--text-secondary)" }}>Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="al-input" data-testid="admin-password"/>
        </label>
        <button type="submit" disabled={loading} className="w-full rounded-full px-6 py-3 text-sm disabled:opacity-60" style={{ background: "var(--primary)", color: "#fff" }} data-testid="admin-login-submit">
          {loading ? "Signing in..." : "Sign in"}
        </button>
        <style>{`
          .al-input { width:100%; padding:12px 14px; border-radius:14px; border:1px solid var(--border-soft); background:var(--bg-primary); color:var(--text-primary); font-size:15px; }
          .al-input:focus { border-color:var(--primary); box-shadow: 0 0 0 3px rgba(143,163,150,0.18); outline:none; }
        `}</style>
      </form>
    </div>
  );
}
